import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Icon } from '@bwoty-web/ui-kit';
import { UI_CHEVRON_RIGHT } from '@bwoty-web/ui-kit/icons';
import formatPrice from '../../../shared/utils/priceFormater';
import discountTypeEnum from '../../../shared/constants/discountType';
import './pricePanel.scss';

const PricePanel = (props) => {
  const { price, siteId, discountType, buttonText, url } = props;
  const { original, discount, toPay, labels } = price;

  const hasDiscount = price.discount > 0;
  const isVingOrGlobe = [1, 18].includes(siteId);
  const priceClass = (isMobilePrice) => {
    return classNames({
      'po-list-price': !isMobilePrice,
      'po-list-price--discounted': hasDiscount && !isVingOrGlobe,
      'po-list-price-mobile': isMobilePrice,
      'po-list-price-mobile--discounted':
        isMobilePrice && hasDiscount && !isVingOrGlobe,
    });
  };

  // true since pricePerPerson should be rounded up and
  // since total price always will be an integer value anyway.
  const roundUp = true;
  return (
    <div className="po-list-price-panel">
      <div className="po-list-price-wrapper">
        {hasDiscount && discountType === discountTypeEnum.showDiscount ? (
          <span className="po-list-discount">
            <span>{`${formatPrice(discount, siteId, roundUp)} `}</span>
            {labels?.discount}
          </span>
        ) : null}
        {hasDiscount && discountType === discountTypeEnum.showOrdinaryPrice ? (
          <span className="po-list-original-price">
            {formatPrice(original, siteId, roundUp)}
          </span>
        ) : null}
        <span className={priceClass(false)}>
          {formatPrice(toPay, siteId, roundUp)}
        </span>
        <span className="po-list-sub-label">{labels?.priceDescription}</span>
      </div>
      <div className="po-list-price-button-wrapper">
        <span className={priceClass(true)}>
          {formatPrice(toPay, siteId, roundUp)}
        </span>
        <Button
          className="po-list-button"
          variant="primary"
          href={url}
        >
          {buttonText}
        </Button>
        <Icon
          className="po-list-mobile-button"
          path={UI_CHEVRON_RIGHT}
          size="s"
          alt={buttonText}
        />
      </div>
    </div>
  );
};

PricePanel.propTypes = {
  price: PropTypes.shape({
    original: PropTypes.number,
    discount: PropTypes.number,
    toPay: PropTypes.number,
    showPerPax: PropTypes.bool,
    labels: PropTypes.shape({
      discount: PropTypes.string,
      priceDescription: PropTypes.string,
    }),
  }).isRequired,
  siteId: PropTypes.number.isRequired,
  discountType: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default PricePanel;
